import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ApplicationState, WithCompanyId, WithScope } from '@mews-commander/types';
import { ResponsiveTwoColumns } from '@mews-commander/ui';
import { hasReadOnlyPrivilegesForCompanyData } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import CustomerTable from './CustomerEntityContainers/Customer';

interface StateProps {
    readOnlyForm: boolean;
}

type RelatedContactsProps = WithScope & WithCompanyId & StateProps;

const RelatedContacts = ({ scope, companyId, readOnlyForm }: RelatedContactsProps) => (
    <ResponsiveTwoColumns>
        <CustomerTable
            scope={`company-contacts-${scope}`}
            // @ts-expect-error $TSFixMeError: Type '{ scope: string; ownerId: string; closeAction: (relatedCustomerId: string) => void; noTitleMargin: true; }' is not...
            ownerId={companyId}
            noTitleMargin
            readOnlyForm={readOnlyForm}
        />
    </ResponsiveTwoColumns>
);

export default connect<StateProps, {}, WithScope & WithCompanyId, ApplicationState>(
    createStructuredSelector({
        readOnlyForm: hasReadOnlyPrivilegesForCompanyData,
    })
)(RelatedContacts);
